export const CheckoutActionTypes = {
    PAYMENT_OPTIONS_START: "PAYMENT_OPTIONS_START",
    PAYMENT_OPTIONS_SUCCESS: "PAYMENT_OPTIONS_SUCCESS",
    PAYMENT_OPTIONS_FAILURE: "PAYMENT_OPTIONS_FAILURE",
    COMPLETE_PAYMENT_START: "COMPLETE_PAYMENT_START",
    COMPLETE_PAYMENT_SUCCESS: "COMPLETE_PAYMENT_SUCCESS",
    COMPLETE_PAYMENT_FAILURE: "COMPLETE_PAYMENT_FAILURE",
    FETCH_USER_TRANSACTION_START: "FETCH_USER_TRANSACTION_START",
    FETCH_USER_TRANSACTION_SUCCESS: "FETCH_USER_TRANSACTION_SUCCESS",
    FETCH_USER_TRANSACTION_FAILURE: "FETCH_USER_TRANSACTION_FAILURE",
    FETCH_ALL_CHECKOUT_START: "FETCH_ALL_CHECKOUT_START",
    FETCH_ALL_CHECKOUT_SUCCESS: "FETCH_ALL_CHECKOUT_SUCCESS",
    FETCH_ALL_CHECKOUT_FAILURE: "FETCH_ALL_CHECKOUT_FAILURE",
}